import { Locale } from 'modules/i18n';

export const trafficChartTranslation = {
  [Locale.en]: {
    title: 'Traffic',
  },
};
